import React, { useState } from 'react';

export default function MobileTable({ data = [], searchable = true }) {
  const [searchTerm, setSearchTerm] = useState('');
  // Фільтруємо дані за пошуковим запитом
  const filteredData = searchTerm 
    ? data.filter(item => 
        item.article.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.barcode.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : data;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    }}>      {/* Поле пошуку */}
      {searchable && data.length > 0 && (
        <div style={{
          marginBottom: '12px',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <input
            type="text"
            placeholder="Пошук по товарах..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              flex: 1,
              padding: '8px 12px',
              border: '1px solid #ddd',
              borderRadius: '6px',
              fontSize: '14px',
              outline: 'none',
              boxSizing: 'border-box'
            }}
            onFocus={(e) => (e.target.style.borderColor = '#007bff')}
            onBlur={(e) => (e.target.style.borderColor = '#ddd')}
          />
          <button
            onClick={() => setSearchTerm('')}
            style={{
              padding: '8px',
              border: 'none',
              background: '#f8f9fa',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '16px',
              color: '#6c757d',
              minWidth: '44px',
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}            title="Очистити пошук"
          >
            ✖
          </button>
        </div>
      )}

      {/* Таблиця-список */}
      <div style={{
        flex: 1,
        overflow: 'auto',
        border: '1px solid #e0e0e0',
        borderRadius: '6px',
        backgroundColor: '#fff'
      }}>
        {filteredData.length === 0 ? (
          <div style={{
            padding: '32px',
            textAlign: 'center',
            color: '#666'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.5 }}>
              {searchTerm ? '🔍' : '📦'}
            </div>            <h3 style={{ margin: '0 0 8px 0' }}>
              {searchTerm ? 'Нічого не знайдено' : 'Немає даних'}
            </h3>
            <p style={{ margin: 0, fontSize: '14px' }}>
              {searchTerm 
                ? `За запитом "${searchTerm}" нічого не знайдено`
                : 'Відсутні дані для відображення'
              }
            </p>
          </div>
        ) : (
          <table style={{
            width: '100%',
            borderCollapse: 'collapse'
          }}>
            <tbody>
              {filteredData.map((item, index) => {                const diff = Number(item.difference || 0);
                const fact = Number(item.fact || 0);
                
                let diffBackgroundColor = 'transparent';
                let diffColor = '#666';
                
                if (diff === 0) {
                  diffBackgroundColor = '#c8e6c9'; // Зеленый фон - точное совпадение
                  diffColor = '#2e7d32';
                } else if (fact === 0) {
                  diffBackgroundColor = 'white'; // Белый фон - нет факта
                  diffColor = '#666';
                } else if (diff > 0) {
                  diffBackgroundColor = '#f8bbd9'; // Мадиновый фон - избыток
                  diffColor = '#ad1457';
                } else if (diff < 0) {
                  diffBackgroundColor = '#ffecb3'; // Оранжевый фон - недостача
                  diffColor = '#f57c00';
                }

                return (
                  <tr key={item.id}>
                    <td style={{
                      padding: '12px 8px',
                      borderBottom: index === filteredData.length - 1 ? 'none' : '1px solid #f0f0f0',
                      verticalAlign: 'top'
                    }}>
                      <div style={{
                        display: 'flex',
                        gap: '12px',
                        alignItems: 'flex-start'
                      }}>
                        {/* Секция 1: Артикул и штрихкод */}
                        <div style={{
                          flex: '0 0 80px',
                          minWidth: '80px'
                        }}>
                          <div style={{
                            fontSize: '14px',
                            fontWeight: 'bold',
                            color: '#333',
                            marginBottom: '4px',
                            wordBreak: 'break-all'
                          }}>
                            {item.article}
                          </div>
                          <div style={{
                            fontSize: '11px',
                            color: '#666',
                            wordBreak: 'break-all'
                          }}>
                            {item.barcode}
                          </div>
                        </div>

                        {/* Секция 2: Наименование */}
                        <div style={{
                          flex: '1 1 0',
                          minWidth: 0,
                          maxWidth: '50vw', // ограничение ширины на мобильном
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          fontSize: '13px',
                          color: '#222',
                          fontWeight: 500
                        }} title={item.name}>
                          {item.name}
                        </div>
                        {/* Секция 3: План/Факт */}
                        <div style={{
                          flex: '0 0 90px',
                          minWidth: '90px',
                          textAlign: 'right',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-end',
                          gap: '2px',
                          marginLeft: 'auto'
                        }}>
                          <span style={{ fontSize: '13px', fontWeight: 500 }}>План: <span style={{ color: '#333' }}>{item.plan}</span></span>
                          <span style={{ fontSize: '13px', fontWeight: 500 }}>Факт: <span style={{ color: '#2e7d32' }}>{item.fact}</span></span>
                          <span style={{
                            fontSize: '12px',
                            fontWeight: 500,
                            color: diffColor,
                            background: diffBackgroundColor,
                            borderRadius: '3px',
                            padding: '1px 4px',
                            marginTop: '2px',
                            minWidth: '60px',
                            textAlign: 'right',
                            display: 'inline-block'
                          }}>Δ {item.difference}</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
